var WeakMap = require('./_WeakMap');

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/~/lodash/_metaMap.js
 **/